import { IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { InputMoney } from '../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../components/RiskRating';
import {
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../components/TableContent';
import { messageError } from '../../../../../../../store/batchTicket/constants';
import { BillingTypeSelect } from '../../../../Resume/components/Detail/components/BillingTypeSelect';

import { AddedProductResponsiveItemCoesProps } from '.';

export const AddedProductItemCoesTablet: React.FC<AddedProductResponsiveItemCoesProps> = ({
  data,
  additionalInfoComponent,
  inputMoneyDataProps,
  onRemoveProduct,
  type,
}) => {
  return (
    <VStack w={'full'}>
      <HStack justifyContent="space-between" w="full" space={Spacing['inline.quarck']}>
        <TableContentItemColumn flex={2} space={Spacing['inline.quarck']}>
          <TableContentItemText>
            {data.fantasyName} {data.asset}
          </TableContentItemText>
          <TableContentItemText color="neutral.medium">{data.strategy}</TableContentItemText>
        </TableContentItemColumn>
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <TableContentItemText>Vencimento</TableContentItemText>
          <TableContentItemText>
            {Utils.Mask.DateFormat(data.maturityDate, 'dd/MM/yyyy')}
          </TableContentItemText>
        </TableContentItemColumn>
        {additionalInfoComponent}
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <TableContentItemText>Risco</TableContentItemText>
          <RiskRating
            currentRiskRating={data?.suitabilityProductRisk?.scoreAdjusted || 0}
            tooltip={data?.suitabilityProductRisk?.risk || messageError}
          />
        </TableContentItemColumn>
        <TableContentItemColumn maxW={'100px'} space={Spacing['inline.quarck']}>
          <TableContentItemText>Aplicação mín.</TableContentItemText>
          <TableContentItemText>{Utils.Mask.Money(data.minimumApplication)}</TableContentItemText>
        </TableContentItemColumn>
      </HStack>
      <HStack w="full" space={Spacing['inline.xxxs']} alignItems="center">
        {type === 'requiredAttention' && <BillingTypeSelect data={data} />}
        <TableContentItemColumn space={Spacing['stack.quarck']}>
          <TableContentItemText>Valor a aplicar</TableContentItemText>
          <HStack alignItems="center" space={Spacing['inline.xxxs']}>
            <InputMoney {...inputMoneyDataProps} />
            <IconButton
              testId="icon-button"
              borderRadius={BoxRadius.sm}
              icon="Trash"
              p={0}
              iconColor={Color['feedback.error.default']}
              iconSize="xs"
              onPress={onRemoveProduct}
            />
          </HStack>
        </TableContentItemColumn>
      </HStack>
    </VStack>
  );
};
